import classNames from 'classnames';
import type { Op } from 'quill/core';
import React, { useState } from 'react';
import useAppSelector, { useAppDispatch } from '../../app/redux/useAppSelector';
import CollapsibleContent from '../../components/CollapsibleContent';
import { MenuItem } from '../../components/Menu';
import OverflowMenu from '../../components/OverflowMenu';
import RichTextDescriptionEditor from '../../editor/RichTextDescriptionEditor';
import editIcon from '../../icons/non-prefilled/16x16/editPost.svg';
import { UIActions } from '../../ui/uiSlice';
import * as styles from './ReadonlyOrganizationSummary.module.scss';

interface ReadonlyOrganizationSummaryProps {
  summary: Op[] | null;
  onStartEditing: () => void;
}

const ReadonlyOrganizationSummary = ({
  summary,
  onStartEditing,
}: ReadonlyOrganizationSummaryProps) => {
  const [isOverflowMenuOpen, setIsOverflowMenuOpen] = useState(false);

  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(
    (state) => state.session.user.type === 'ADMIN',
  );
  const isCollapsed = useAppSelector(
    (state) => state.ui.isOrganizationSummaryCollapsed,
  );

  return (
    <div className={styles.container}>
      {summary ? (
        <div className={styles.editor}>
          <CollapsibleContent
            maxHeight={232}
            collapsed={isCollapsed}
            onCollapsedChange={(value) =>
              dispatch(UIActions.toggleOrganizationSummaryCollapsed(value))
            }
          >
            {(onContentChange) => (
              <RichTextDescriptionEditor
                readOnly
                namespace="organizationSummary"
                defaultValue={summary}
                onTextChange={onContentChange}
                onMount={onContentChange}
              />
            )}
          </CollapsibleContent>
        </div>
      ) : (
        <div className={styles.header}>
          <h1>Home</h1>
        </div>
      )}
      {isAdmin && (
        <div
          className={classNames(styles.overflowMenu, {
            [styles.open]: isOverflowMenuOpen,
          })}
        >
          <OverflowMenu
            open={isOverflowMenuOpen}
            onOpenChange={setIsOverflowMenuOpen}
          >
            <MenuItem icon={editIcon} onClick={onStartEditing}>
              Edit description
            </MenuItem>
          </OverflowMenu>
        </div>
      )}
    </div>
  );
};

export default ReadonlyOrganizationSummary;
